
import { mapState } from "vuex";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  computed: {
    ...mapState("BrochureAanvraag", ["loading"])
  }
})
export default class SearchFilter extends Vue {
  searchtext = "";

  @Watch("searchtext")
  textChanged() {
    this.$store.commit("BrochureAanvraag/searchChanged", {
      value: this.searchtext
    });
  }
}
